<template>
  <v-navigation-drawer :value="this.getInventoryDrawerState" class="cartDrawer inventory-drawer"
                       stateless temporary app right>
    <v-card class="three-color-grad cartDrawerWrapper">
      <v-toolbar color="transparent" elevation="0" class="cartContentHeader" height="70">
        <v-btn fab small class="closeCartBtn" @click="closeInventoryDrawer">
          <close-btn/>
        </v-btn>
        <v-toolbar-title class="pl-3 text--black">
          Inventurliste
        </v-toolbar-title>
      </v-toolbar>
      <v-container class="cartContentWrapper" v-if="getInventoryDrawerState">

        <span v-if="!getLoadingState && getInventoryPersonal.data.length === 0" class="emptyCartInfo">
          Du hast noch keine Artikel zur Inventurliste hinzugefügt.
        </span>

        <v-virtual-scroll class="inventory-list_v-scroll" item-height="181"
                          bench="2"
                          :items="getInventoryPersonal.data"
                          v-if="!getLoadingState && getInventoryPersonal !== null"
        >
          <template v-slot:default="{index, item}">
            <v-card class="article-card_no-img" :key="index">
              <div class="article-card__desc-no-img">
                {{ item.description }}
              </div>
              <div class="article-card__itemNo-no-img">
                Artikelnummer: {{ item.itemNo }}
              </div>
              <div class="article-card__ordered-type-no-img">
                {{ item.amount }} {{ item.unit | capitalize}}
              </div>
              <div class="article-card__price-no-img">
                <span class="total-price">
                  {{ item.price | parsePrice2Digits }} €
                </span>
                <span class="single-price">
                  Einzelpreis: {{ item.singlePrice | parsePrice2Digits }} €
                </span>
              </div>
            </v-card>
            <v-btn class="v-scroll_btn-delete" @click="removeFromInventoryList(item, index)">
              <TrashCan/>
            </v-btn>
          </template>

        </v-virtual-scroll>

      </v-container>

      <v-card elevation="10" class="cartBottomCard" light>
        <v-container class="cartBottomWrapper">
          <v-row>
            <v-col cols="12" class="textSize__14">
              Gesamtsumme:
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span class="articlePriceMain" v-if="!this.getLoadingState && getInventoryDrawerState">{{ getInventoryPersonal.totalPrice| parsePrice2Digits}} €</span>
              <span class="articlePriceUVP" v-if="!this.getLoadingState">netto</span>
              <v-skeleton-loader type="text" v-if="this.getLoadingState" class="articlePriceMainSkeleton"/>
           </v-col>
          </v-row>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-btn class="textSize__16 checkOutBtn"
                     @click="goToInventoryCheckout"
              >
                <inventory-icon-white/>
                <span class="pl-3 text--white">
                  Zur gesamten Inventurliste
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
import CloseBtn from "@/assets/closeBtn";
import router from "@/router";
import TrashCan from "@/assets/cart/trashCan";
import InventoryIconWhite from "@/assets/inventory/inventoryIconWhite";

export default {
  name: "inventoryDrawer",
  components: {InventoryIconWhite, TrashCan, CloseBtn},

  data() {
    return {
      inventory: null,
      value: null,
    }
  },

  methods: {
    ...mapActions('inventory', {
      removeFromInventory: 'removeFromInventory',
      fetchPersonalInventory: 'fetchPersonalInventory'
    }),

    ...mapActions({
      setLoadingState: 'setLoadingState'
    }),

    ...mapMutations('inventory', {
      setInventoryDrawerState: 'setInventoryDrawerState',
    }),

    removeFromInventoryList(item) {
      const params = {
        itemNo: item.itemNo,
        type: item.type,
        uid: this.getUserId
      }
      this.removeFromInventory(params)
    },

    closeInventoryDrawer() {
      this.setInventoryDrawerState(false)
    },

    goToInventoryCheckout() {
      router.push({name: 'InventoryCheckout'})
      this.setInventoryDrawerState(false)
    },

  },

  computed: {
    ...mapGetters('inventory', {
      getInventoryDrawerState: 'getInventoryDrawerState',
      getInventoryPersonal: 'getInventoryPersonal'
    }),

    ...mapGetters({
      getLoadingState: 'getLoadingState',
      getUserId: 'getUserId'
    })
  },

  watch: {
    getInventoryDrawerState: {
      async handler(role) {
        if(role) {
          this.fetchPersonalInventory().then(() => {
            this.setLoadingState(false)
          })
        }
        else if(!role) {
          this.setLoadingState(true)
        }
      }
    }
  }
}
</script>

<style>

  .inventory-list_v-scroll {
    height: calc(100vh * 0.98 - 70px - 130px);
  }

  .article-card_no-img {
    border-radius: 30px 0px 0px 30px!important;
    height: 169px;
    width: 100%;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: 33px 39px 33px 40px;
    background-color: white;
    border-radius: 30px;
    overflow: hidden;
    padding: 12px 16px;
  }

  .article-card__image {
    height: 40px;
    width: 40px;
    background-color: gray;
    grid-row-start: 1;
    grid-row-end: 5;
    grid-column-start: 1;
    grid-column-end: 1;
    margin-top: 4px;
  }

  .article-card__desc-no-img {
    border-top-left-radius: unset!important;
    font-size: 16px;
    color: var(--igros-black);
    grid-row-start: 1;
    grid-column-start: 1;
    grid-column-end: 1;
    align-self: center;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .article-card__itemNo-no-img {
    font-size: 14px;
    color: var(--igros-black);
    grid-row-start: 2;
    grid-column-start: 1;
    grid-column-end: 1;
    align-self: center;
    text-align: left;
  }

  .article-card__price-single-no-img {
    font-size: 22px;
    color: #525252;
    grid-row-start: 3;
    grid-column-start: 1;
    grid-column-end: 1;
    font-weight: 700;
    align-self: center;
    text-align: left;
  }

  .article-card__ordered-type-no-img {
    font-size: 14px;
    color: var(--igros-black);
    grid-row-start: 3;
    grid-column-start: 1;
    grid-column-end: 1;
    font-weight: 700;
    align-self: center;
    text-align: left;
  }

  .article-card__price-no-img {
    grid-row-start: 4;
    grid-column-start: 1;
    grid-column-end: 1;
    align-self: center;
    text-align: left;
  }

  .article-card__price-no-img .total-price {
    font-size: 22px;
    color: #525252;
    font-weight: 700;
  }

  .article-card__price-no-img .single-price {
    margin-left: 10px;
    font-size: 12px;
    color: var(--igros-black);
  }

  .inventory-drawer {
    min-width: 320px;
  }

</style>
